<template>
  <div class="merchant">
    <v-toolbar
      color="white"
      fixed
      app
      flat
      tabs
      :class="salePageIsActive && showSearch ? 'dis-toolbat-content' : ''"
      :style="salePageIsActive && showSearch ? 'position: inherit;' : ''"
    >
      <template v-if="!showSearch">
        <v-spacer />
        <v-toolbar-title v-if="merchant != null">
          <img
            src="@/assets/img/logo/nestle_logo.png"
            style="max-height: 40px"
          />
        </v-toolbar-title>
        <v-spacer />

        <v-menu data-app offset-y attach>
          <template v-slot:activator="{ on }">
            <v-toolbar-title v-on="on">
              <v-layout>
                <v-flex>
                  <flag :iso="$i18n.locale() == 'en' ? 'gb' : $i18n.locale()" />
                  &nbsp;
                  {{ $i18n.locale() ? $i18n.locale().toUpperCase() : '' }}
                </v-flex>
                <v-flex>
                  <v-icon>mdi-chevron-down</v-icon>
                </v-flex>
              </v-layout>
            </v-toolbar-title>
          </template>

          <v-list>
            <v-list-tile
              v-for="(item, lindex) in langOption"
              :key="'lang_' + lindex"
              @click="onChangeLang(item.value)"
            >
              <v-list-tile-title>
                <flag :iso="item.flag" />
                &nbsp; {{ item.value.toUpperCase() }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </template>
      <slot name="search"></slot>

      <template v-slot:extension>
        <slot name="category"></slot>
        <slot name="header"></slot>
      </template>
    </v-toolbar>
  </div>
</template>

<script>
import MerchatDetailMixin from './MerchatDetailMixin.js'
export default {
  mixins: [MerchatDetailMixin],
  name: 'NestleMerchantDetail',
  computed: {
    langOption() {
      var langOptions = [
        {
          flag: 'gb',
          value: 'en'
        },
        {
          flag: 'th',
          value: 'th'
        }
      ]
      return langOptions.filter((el) => {
        return true
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
